import TemplateStyleTransformer from '@intercom/embercom-composer/lib/template-style-transformer';
import HtmlBlockStyleTransformer from '@intercom/embercom-composer/lib/html-block-style-transformer';
import Em from 'ember';
const TemplateTransformer = function (template) {
  this.styleTransformer = new TemplateStyleTransformer();
  this.template = template;
};
let processingTemplateCount = 0;
TemplateTransformer.isNotProcessingTemplates = function () {
  return processingTemplateCount === 0;
};
TemplateTransformer.prototype.process = function () {
  processingTemplateCount++;
  return new Em.RSVP.Promise(function (resolve) {
    this.styleTransformer.processTemplate(this.template.name, this.template.html).then(function (transformedTemplate) {
      let processedTemplate = this._processTransformedTemplate(transformedTemplate);
      resolve(processedTemplate);
      processingTemplateCount--;
    }.bind(this));
  }.bind(this));
};
TemplateTransformer.prototype.transformHtmlBlockStyles = function (blocks) {
  HtmlBlockStyleTransformer.process(blocks, this.styleTransformer);
};
TemplateTransformer.prototype._processTransformedTemplate = function (transformedTemplate) {
  transformedTemplate = this._replacePlaceholders(transformedTemplate, this.template.data);
  transformedTemplate = this._addContentNode(transformedTemplate);
  transformedTemplate = this._addWidgetNodes(transformedTemplate);
  return transformedTemplate;
};
TemplateTransformer.prototype._replacePlaceholders = function (template, data) {
  for (let prop in data) {
    //eslint-disable-next-line no-prototype-builtins
    if (data.hasOwnProperty(prop)) {
      template = template.replace(new RegExp(`{{\\s*${prop}\\s*}}`, 'gi'), data[prop]);
    }
  }
  return template;
};
TemplateTransformer.prototype._addContentNode = function (transformedTemplate) {
  return transformedTemplate.replace(/{{[ {2}]*content[ {2}]*}}/i, '<div id="composer-content"></div>');
};
TemplateTransformer.prototype._addWidgetNodes = function (transformedTemplate) {
  return transformedTemplate.replace(/\{\{widget\.([a-z]+)\}\}/g, '<div class="customisable-widget $1"></div>');
};
export default TemplateTransformer;